import "react-tooltip/dist/react-tooltip.css";

import { createRoot } from "react-dom/client";

import { Authentication, ConfigurationManager } from "@/utils";

import Root from "./components/core/Root";
import { configureStore } from "./store/configure-store";

const store = configureStore();

ConfigurationManager.refreshConfigurationFile().then(async () => {
    const config = ConfigurationManager.values;

    const msal = config.auth
        ? await Authentication.initMsal(config.auth)
        : null;

    const container = document.getElementById("root");
    const root = createRoot(container);
    root.render(<Root store={store} msal={msal} />);
});
